import React, { useState, useEffect } from "react";
import NominationSelection from "./NominationSelection";
import NominationDisplay from "./NominationDisplay";
import JudgesDisplay from "./JudgesDisplay";

const ScreenPanel = ({ 
  competitionId, 
  config, 
  onConfigChange, 
  onSettingsClick, 
  onSwitchScreenMode,
  routes, 
  t, 
  isQuadMode 
}) => {
  const [nominations, setNominations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (config.mode === 'nomination_selection') {
      fetchNominations();
    }
  }, [config.mode]);

  const fetchNominations = async () => {
    try {
      setLoading(true);
      const response = await fetch(routes.nominations_data, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setNominations(data.nominations);
    } catch (error) {
      console.error('Error fetching nominations:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleNominationSelect = (nominationId) => {
    onConfigChange({
      mode: 'nomination_display',
      selectedNomination: nominationId,
      selectedView: 'nomination'
    });
  };

  const handleJudgesSelect = () => {
    onConfigChange({
      mode: 'judges_display',
      selectedView: 'judges'
    });
  };

  const handleBackToSelection = () => {
    onConfigChange({
      mode: 'nomination_selection',
      selectedNomination: null,
      selectedView: null
    });
  };

  const handleSwitchToSingle = () => {
    if (onSwitchScreenMode) {
      onSwitchScreenMode('single');
    }
  };

  const handleSwitchToQuad = () => {
    if (onSwitchScreenMode) {
      onSwitchScreenMode('quad');
    }
  };

  return (
    <div className={`screen-panel ${isQuadMode ? 'quad-mode' : 'single-mode'}`}>
      {/* Settings button */}
      <button
        className="settings-btn"
        onClick={onSettingsClick}
        title={t.settings}
      >
        <i className="fa-solid fa-cog"></i>
      </button>

      {/* Content based on current mode */}
      {config.mode === 'nomination_selection' && (
        <NominationSelection
          nominations={nominations}
          loading={loading}
          onNominationSelect={handleNominationSelect}
          onJudgesSelect={handleJudgesSelect}
          onSwitchToSingle={handleSwitchToSingle}
          onSwitchToQuad={handleSwitchToQuad}
          isQuadMode={isQuadMode}
          t={t}
        />
      )}

      {config.mode === 'nomination_display' && config.selectedNomination && (
        <NominationDisplay
          competitionId={competitionId}
          nominationId={config.selectedNomination}
          routes={routes}
          onBack={handleBackToSelection}
          t={t}
          isQuadMode={isQuadMode}
        />
      )}

      {config.mode === 'judges_display' && (
        <JudgesDisplay
          competitionId={competitionId}
          routes={routes}
          onBack={handleBackToSelection}
          t={t}
          isQuadMode={isQuadMode}
        />
      )}
    </div>
  );
};

export default ScreenPanel;